import { defineComponent, getCurrentInstance } from "@vue/composition-api";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
export default defineComponent({
  name: "UnsyncedAppsModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    nrOfUnsyncedApps: {
      type: Number,
      required: true
    }
  },
  setup() {
    const internalInstance = getCurrentInstance();
    const handleHide = () => {
      (internalInstance == null ? void 0 : internalInstance.proxy).$hideModal();
    };
    return {
      handleHide
    };
  }
});